import React, { useState } from 'react';
import { StatCard } from '../Shared/StatCard';
import { CheckCircleIcon, FileTextIcon, PlusIcon, TrendingUpIcon, UsersIcon, BuildingIcon, DollarSignIcon, PercentIcon, CalendarIcon } from 'lucide-react';
import { DBRSExportModal } from './DBRSExportModal';
export function CapitalMarketsDashboard() {
  const [isDBRSModalOpen, setIsDBRSModalOpen] = useState(false);
  const handleRunCapitalCheck = () => {
    console.log('Running capital readiness check...');
  };
  const handleViewDBRSReport = () => {
    setIsDBRSModalOpen(true);
  };
  const handleCloseDBRSModal = () => {
    setIsDBRSModalOpen(false);
  };
  const handleCreateNewPool = () => {
    console.log('Creating new pool...');
  };
  return <div className="space-y-6 max-w-6xl mx-auto" data-id="element-2">
      <div className="flex justify-between items-center" data-id="element-3">
        <h2 className="text-xl font-semibold text-foreground" data-id="element-4">
          Capital Markets Dashboard
        </h2>
        <div className="flex space-x-3" data-id="element-5">
          <button className="px-4 py-2 bg-background border border-border rounded-full text-foreground/70 hover:bg-muted flex items-center text-sm transition-colors" onClick={handleRunCapitalCheck} data-id="element-6">
            <CheckCircleIcon className="w-4 h-4 mr-2" data-id="element-7" />
            Run Capital Readiness Check
          </button>
          <button className="px-4 py-2 bg-background border border-border rounded-full text-foreground/70 hover:bg-muted flex items-center text-sm transition-colors" onClick={handleViewDBRSReport} data-id="element-8">
            <FileTextIcon className="w-4 h-4 mr-2" data-id="element-9" />
            View DBRS Report
          </button>
          <button className="px-4 py-2 bg-success rounded-full text-foreground/70 hover:bg-success/80 flex items-center text-sm transition-colors" onClick={handleCreateNewPool} data-id="element-10">
            <PlusIcon className="w-4 h-4 mr-2" data-id="element-11" />
            Create New Pool
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-12">
        <StatCard title="Total Loans" value="42" icon={<FileTextIcon className="w-5 h-5 text-accent-foreground" data-id="element-14" />} trend={{
        value: 12,
        label: 'vs last month'
      }} data-id="element-13" />
        <StatCard title="Active Pools" value="6" icon={<BuildingIcon className="w-5 h-5 text-accent-foreground" data-id="element-16" />} trend={{
        value: 2,
        label: 'vs last month'
      }} data-id="element-15" />
        <StatCard title="Total AUM" value="$24.5M" icon={<DollarSignIcon className="w-5 h-5 text-accent-foreground" data-id="element-18" />} trend={{
        value: 8,
        label: 'vs last month'
      }} data-id="element-17" />
        <StatCard title="Avg. DSCR" value="1.25" icon={<PercentIcon className="w-5 h-5 text-accent-foreground" data-id="element-20" />} trend={{
        value: -2,
        label: 'vs last month'
      }} data-id="element-19" />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-21">
        <div className="bg-card rounded-lg border border-border shadow-sm p-6" data-id="element-22">
          <h3 className="text-lg font-medium text-card-foreground mb-4" data-id="element-23">
            Upcoming Deadlines
          </h3>
          <div className="space-y-4" data-id="element-24">
            <div className="flex items-start p-3 bg-muted rounded-md" data-id="element-25">
              <CalendarIcon className="w-5 h-5 text-muted-foreground mt-0.5 mr-3" data-id="element-26" />
              <div data-id="element-27">
                <p className="text-sm font-medium text-card-foreground" data-id="element-28">
                  DBRS Monthly Report
                </p>
                <p className="text-xs text-muted-foreground mt-1" data-id="element-29">
                  Due in 3 days
                </p>
              </div>
            </div>
            <div className="flex items-start p-3 bg-muted rounded-md" data-id="element-30">
              <CalendarIcon className="w-5 h-5 text-muted-foreground mt-0.5 mr-3" data-id="element-31" />
              <div data-id="element-32">
                <p className="text-sm font-medium text-card-foreground" data-id="element-33">
                  Quarterly Investor Call
                </p>
                <p className="text-xs text-muted-foreground mt-1" data-id="element-34">
                  Due in 7 days
                </p>
              </div>
            </div>
            <div className="flex items-start p-3 bg-muted rounded-md" data-id="element-35">
              <CalendarIcon className="w-5 h-5 text-muted-foreground mt-0.5 mr-3" data-id="element-36" />
              <div data-id="element-37">
                <p className="text-sm font-medium text-card-foreground" data-id="element-38">
                  Loan Pool Closing
                </p>
                <p className="text-xs text-muted-foreground mt-1" data-id="element-39">
                  Due in 14 days
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-card rounded-lg border border-border shadow-sm p-6" data-id="element-40">
          <h3 className="text-lg font-medium text-card-foreground mb-4" data-id="element-41">
            Recent Activity
          </h3>
          <div className="space-y-4" data-id="element-42">
            <div className="flex items-start" data-id="element-43">
              <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center mr-3" data-id="element-44">
                <FileTextIcon className="w-4 h-4 text-primary" data-id="element-45" />
              </div>
              <div data-id="element-46">
                <p className="text-sm font-medium text-card-foreground" data-id="element-47">
                  DBRS Report Submitted
                </p>
                <p className="text-xs text-muted-foreground mt-1" data-id="element-48">
                  2 hours ago by Sarah
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-49">
              <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center mr-3" data-id="element-50">
                <UsersIcon className="w-4 h-4 text-primary" data-id="element-51" />
              </div>
              <div data-id="element-52">
                <p className="text-sm font-medium text-card-foreground" data-id="element-53">
                  New Buyer Added
                </p>
                <p className="text-xs text-muted-foreground mt-1" data-id="element-54">
                  Yesterday by Michael
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-55">
              <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center mr-3" data-id="element-56">
                <TrendingUpIcon className="w-4 h-4 text-primary" data-id="element-57" />
              </div>
              <div data-id="element-58">
                <p className="text-sm font-medium text-card-foreground" data-id="element-59">
                  Pool Performance Updated
                </p>
                <p className="text-xs text-muted-foreground mt-1" data-id="element-60">
                  2 days ago by System
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-card rounded-lg border border-border shadow-sm p-6" data-id="element-61">
          <h3 className="text-lg font-medium text-card-foreground mb-4" data-id="element-62">
            Capital Readiness
          </h3>
          <div className="space-y-4" data-id="element-63">
            <div data-id="element-64">
              <div className="flex justify-between items-center mb-1" data-id="element-65">
                <span className="text-sm text-muted-foreground" data-id="element-66">
                  DBRS Eligibility
                </span>
                <span className="text-sm font-medium text-card-foreground" data-id="element-67">
                  92%
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2" data-id="element-68">
                <div className="bg-success h-2 rounded-full" style={{
                width: '92%'
              }} data-id="element-69"></div>
              </div>
            </div>
            <div data-id="element-70">
              <div className="flex justify-between items-center mb-1" data-id="element-71">
                <span className="text-sm text-muted-foreground" data-id="element-72">
                  Documentation
                </span>
                <span className="text-sm font-medium text-card-foreground" data-id="element-73">
                  78%
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2" data-id="element-74">
                <div className="bg-warning h-2 rounded-full" style={{
                width: '78%'
              }} data-id="element-75"></div>
              </div>
            </div>
            <div data-id="element-76">
              <div className="flex justify-between items-center mb-1" data-id="element-77">
                <span className="text-sm text-muted-foreground" data-id="element-78">
                  Buyer Guidelines
                </span>
                <span className="text-sm font-medium text-card-foreground" data-id="element-79">
                  100%
                </span>
              </div>
              <div className="w-full bg-muted rounded-full h-2" data-id="element-80">
                <div className="bg-success h-2 rounded-full" style={{
                width: '100%'
              }} data-id="element-81"></div>
              </div>
            </div>
            <div className="pt-4 mt-2 border-t border-border" data-id="element-82">
              <button className="w-full py-2 bg-primary/10 text-primary rounded-md hover:bg-primary/20 flex items-center justify-center" data-id="element-83">
                <CheckCircleIcon className="w-4 h-4 mr-2" data-id="element-84" />
                Run Full Readiness Check
              </button>
            </div>
          </div>
        </div>
      </div>
      <DBRSExportModal isOpen={isDBRSModalOpen} onClose={handleCloseDBRSModal} templateType="DBRS Surveillance" reportingPeriod="Q3 2025" data-id="element-85" />
    </div>;
}